import { useRef, useState } from 'react';
import { PersonalizeType, VIRTUAL_PERSONALIZE_MAP } from '@portalCommon/constants';
import { useInViewport } from '@fuxi/eevee-hooks';
import classnames from 'classnames/bind';
import { DEFAULT_IMG } from 'common-package';
import Match from './components/match';
import { SIDE_LIST } from './helper';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const PersonalizedAvatar = () => {
  const [currentSide, setCurrentSide] = useState(SIDE_LIST[0].key);
  const currentItem = VIRTUAL_PERSONALIZE_MAP[currentSide];
  const personalizedRef = useRef(null);
  const [isInViewport] = useInViewport(personalizedRef, {
    rootMargin: '500px',
  });

  const handleSideList = SIDE_LIST.map(item => ({
    ...item,
    unSelectImg: (
      <div
        style={{ backgroundImage: `url(${isInViewport ? item.unSelect : DEFAULT_IMG})` }}
        className={cx('unselect-img', 'img')}>
        <div className={`${cx('text')}`}>{item.text}</div>
      </div>
    ),
    selectedImg: (
      <div
        style={{ backgroundImage: `url(${isInViewport ? item.selected : DEFAULT_IMG})` }}
        className={cx('selected-img', 'img')}>
        <div className={`${cx('text', 'text-selected')}`}>{item.text}</div>
      </div>
    ),
  }));

  return (
    <div className={cx('personalize-container')} ref={personalizedRef}>
      <div className={cx('content')}>
        <div className={cx('left-side')}>
          {handleSideList.map(({ key, selected, unSelect, text, selectedImg, unSelectImg }) => {
            return (
              <div
                key={key}
                className={cx('item')}
                onClick={() => {
                  setCurrentSide(key);
                }}>
                <div className={cx('img-container')}>{currentSide === key ? selectedImg : unSelectImg}</div>
              </div>
            );
          })}
        </div>
        {/* 右边卡片 */}
        <div className={cx('card')}>
          <Match
            thumb={currentItem.thumb}
            side={currentSide}
            video={currentSide === PersonalizeType.Action ? currentItem.video : undefined}
            title={currentItem.title}
            desc={currentItem.desc}
            choseMenus={currentItem?.matchList}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalizedAvatar;
